import { render, staticRenderFns } from "./partyCompany.vue?vue&type=template&id=2706cb31&scoped=true"
import script from "./partyCompany.vue?vue&type=script&lang=js"
export * from "./partyCompany.vue?vue&type=script&lang=js"
import style0 from "./partyCompany.vue?vue&type=style&index=0&id=2706cb31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2706cb31",
  null
  
)

export default component.exports